
import { CompanyIdHoursRequest, ConsumeTokenRequest, FreebieIdRequest, FreebieModel, FreebiesResponse, RfCodeModel, RfCodeRequest } from '@gtpl/shared-models/canteen-management';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { DepartmentService, EmployeeService } from '@gtpl/shared-services/masters';
import { Injectable } from '@nestjs/common';
import { In } from 'typeorm';
import { EmployeeFreebiesEntity } from './entity/employee-freebies.entity';
import { EmployeeFreebiesRepo } from './repository/employee-freebies.repository';
import {DevicesServices, FreebiesServices} from '@gtpl/shared-services/canteen-management';
import { AllDepartmentsResponseModel, AllEmployeesResponseModel, DepartmentDto, EmployeeCodeRequest, EmployeeDto, EmployeeResponseModel } from '@gtpl/shared-models/masters';

@Injectable()
export class TokensHelperService {
    constructor(
        private employeeService: EmployeeService,
        private freebieService: FreebiesServices,
        private empFreebieEntity: EmployeeFreebiesRepo,
        private devicesService: DevicesServices,
        private departmentsService: DepartmentService,
    ) {

    }


    /**
     * checks if the employee code is valid
     */
    async getEmployeeRecordByEmpCode(empCode: string): Promise<EmployeeResponseModel> {
        const req = new EmployeeCodeRequest(empCode);
        const empInfo: EmployeeResponseModel = await this.employeeService.getActiveEmployeesByEmpCode(req);
        console.log('&&&&&&empInfo&&&&&&&',empInfo)
        if (!empInfo.status) {
            throw new ErrorResponse(0, 'Employee info not found for code : ' + empCode);
        }
        return empInfo;
    }

    /**
     * checks if the employee id is valid
     */
    async getEmployeeRecordByEmpId(empId: number): Promise<EmployeeResponseModel> {
        // const req = new EmployeeCodesRequest([empId], '');
        const empInfo: EmployeeResponseModel = null;
        if (!empInfo) {
            throw new ErrorResponse(0, 'Employee info not found for emp id : ' + empId);
        }
        return empInfo.data[0];
    }

    /**
     * checks if the employee rf-id is valid
     */
    // async getEmployeeRecordByEmpRfId(employeeRfId: string, throwErr: boolean): Promise<EmployeeResponseModel> {
    //     const req = new ConsumeTokenRequest(employeeRfId, '', null);
    //     const empInfo: EmployeeResponseModel = await this.employeeService.getEmployeeRecordByEmpRfId(req);
    //     if (!empInfo.status && throwErr) {
    //         throw new ErrorResponse(0, 'Employee info not found for Rf Id : ' + employeeRfId);
    //     }
    //     return empInfo.data[0];
    // }
    
    async getFreebieRecordByFreebieId(freebieId: number): Promise<FreebieModel> {
        const freebieIdReq = new FreebieIdRequest(freebieId, null);
        const freebieInfo: FreebiesResponse = await this.freebieService.getFreebieById(freebieIdReq) //;
        if (!freebieInfo.status) {
            throw new ErrorResponse(0, 'Freebie info not found for : ' + freebieId);
        }
        return freebieInfo.data[0];
    }

    /**
     * gets the employee freebie if defined for an employee + code + month
     * @param empCode 
     * @param freebieId 
     * @param month 
     */
    async getEmployeeFreebieForEmpIdFreebieIdAndMonth(empCode: string, freebieCode: string, month: number): Promise<EmployeeFreebiesEntity> {
        return await this.empFreebieEntity.findOne({ where: { employeeCode: empCode, freebieCode: freebieCode, month: month, isActive: true } });
    }

    /**
     * gets the employee freebie record by id
     * @param empFreebieId 
     * @returns 
     */
    async getEmployeeFreebieRecordById(empFreebieId: number): Promise<EmployeeFreebiesEntity> {
        return await this.empFreebieEntity.findOne({ where: { employeeFreebiesId: empFreebieId, isActive: true } });
    }

    /**
     * gets the employee freebie record by id
     * @param empFreebieId 
     * @returns 
     */
    async getEmployeeFreebieRecordByEmpCodes(empCodes: string[]): Promise<EmployeeFreebiesEntity[]> {
        return await this.empFreebieEntity.find({ where: { employeeCode: In(empCodes), isActive: true }, order: { year: 'ASC', month: 'ASC', freebieId: 'ASC' } });
    }

    /**
     * gets the freebie mapped for the company and the current hour 
     * @param companyId 
     * @param currentHour 
     */
    async getFreebieMappedForCompanyAndHour(companyId: number, currentHour: number): Promise<FreebieModel> {
        const companyIdHourReq = new CompanyIdHoursRequest(companyId, currentHour);
        const freebieRes = await this.freebieService.getFreebieForCompanyAndHours(companyIdHourReq);
        if (!freebieRes.status) {
            throw new ErrorResponse(freebieRes.intlCode, freebieRes.internalMessage);
        }
        return freebieRes.data[0];
    }

    /**
     * gets the rf code model
     * @param rfCode 
     */
    // async getRfCodeByRfCode(rfCode: string): Promise<RfCodeModel> {
    //     const rfCodeReq = new RfCodeRequest(rfCode, '');
    //     const rfCodeRec = await this.devicesService.getRfCodeRecordByRfCode(rfCodeReq);
    //     if (rfCodeRec.status) {
    //         throw new ErrorResponse(0, 'RF code does not exist');
    //     }
    //     return rfCodeRec.data[0];
    // }

    /**
     * gets all the employees
     * @returns 
     */
    async getAllEmployees(): Promise<EmployeeDto[]> {
        const emps: AllEmployeesResponseModel = await this.employeeService.getAllEmployees();
        if (!emps.status) {
            throw new ErrorResponse(emps.intlCode, emps.internalMessage);
        }
        return emps.data;
    }

    /**
     * gets all the departments
     * @returns 
     */
    async getAllDepartments(): Promise<DepartmentDto[]> {
        const departments: AllDepartmentsResponseModel = await this.departmentsService.getAllDepartments();
        if (!departments.status) {
            throw new ErrorResponse(departments.intlCode, departments.internalMessage);
        }
        return departments.data;
    }

    async getAllFreebies(): Promise<FreebieModel[]> {
        const freebies: FreebiesResponse = await this.freebieService.getAllFreebies();
        if (!freebies.status) {
            throw new ErrorResponse(freebies.intlCode, freebies.internalMessage)
        }
        return freebies.data;
    }

    /**
     * get freebies for the given job Hour
     * @param currentHour 
     * @returns 
     */
    async getFreebieForCurrentJobHour(currentHour: number): Promise<FreebieModel[]> {
        const companyJobHour = new CompanyIdHoursRequest(1, currentHour);
        const freebieRes = await this.freebieService.getFreebieForCurrentJobHour(companyJobHour);
        if (!freebieRes.status) {
            throw new ErrorResponse(freebieRes.intlCode, freebieRes.internalMessage);
        }
        return freebieRes.data;
    }
}
